/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Appointments from './Appointments/index'
import Filter from './Filter/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconChair from 'DesignSystem/Svgs/TysiaIconChair/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Chairs/Content"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 id="chairs-sidebar"
 style={{'--tx-1-Z1Yf8zk': isBefore ? "20px" : "0px",'--p-3-Z1Yf8zk': isMedia.mobile ? "absolute" : "relative",'--h-4-Z1Yf8zk': isMedia.mobile ? "100%" : "auto",'--w-5-Z1Yf8zk': isMedia.mobile ? "98%" : "auto",'--ml-2-Z1Yf8zk': isMedia.mobile ? "0px" : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--zi-6-Z1Yf8zk': isMedia.mobile ? 1000 : 0}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-7-Z1Yf8zk': dtColorsWhite,'--bc-8-Z1Yf8zk': dtColorsNeutral400,'--w-5-Z1Yf8zk': isMedia.mobile ? "100%" : "250px"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bbc-9-Z1Yf8zk': dtColorsNeutral400,'--bc-7-Z1Yf8zk': dtColorsWhite,'--bbw-10-Z1Yf8zk': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? "0px" : "1px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconChair
  viewPath={`${viewPath}/TysiaIconChair`}
 width={16}
 height={16}
 fill={dtColorsNeutral900}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h5"
 marginLeft={4}
 text="Chairs"
/>
<Filter
  viewPath={`${viewPath}/Filter`}
/>
</div>
<Appointments
  viewPath={`${viewPath}/Appointments`}
/>
</div>
</div>
{children}
</React.Fragment>)
}